import React from 'react'

export const PointsCurrencyIcon = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16.5"
      cy="16"
      r="13.8125"
      fill="#F4AF25"
      stroke="#FFB800"
      strokeWidth="0.375"
    />
    <circle
      cx="16.4927"
      cy="15.9996"
      r="12.0625"
      fill="url(#paint0_linear_1474_18333)"
      stroke="#F4AF25"
      strokeWidth="0.375"
    />
    <g filter="url(#filter0_dd_1474_18333)">
      <path
        d="M16.4907 8.99976C17.4077 8.99977 18.3174 9.18202 19.1714 9.53198C20.0184 9.88198 20.7889 10.3995 21.4399 11.0505C22.0909 11.7015 22.6085 12.4721 22.9585 13.3191C23.3084 14.173 23.4907 15.0829 23.4907 15.9998C23.4907 17.8547 22.7559 19.64 21.4399 20.949C20.7907 21.5998 20.0187 22.1156 19.1694 22.4675C18.3202 22.8194 17.41 23.0005 16.4907 22.9998C15.5711 22.9985 14.6605 22.8175 13.8101 22.4675C12.9615 22.1154 12.1902 21.5995 11.5415 20.949C10.8906 20.2997 10.3749 19.5278 10.0229 18.6785C9.67101 17.8292 9.48994 16.919 9.49072 15.9998C9.49072 14.1448 10.2255 12.3595 11.5415 11.0505C12.1925 10.3995 12.9631 9.88198 13.8101 9.53198C14.6605 9.18201 15.571 9.00101 16.4907 8.99976ZM19.4966 12.8533C17.8405 12.8534 16.4976 14.1957 16.4976 15.8513C16.4976 17.507 17.8405 18.8492 19.4966 18.8494C21.1529 18.8494 22.4956 17.5071 22.4956 15.8513C22.4955 14.1956 21.1529 12.8533 19.4966 12.8533Z"
        fill="#FFEAB2"
      />
    </g>
    <path
      d="M22.4892 15.8524C22.4892 19.1639 19.8038 21.8485 16.4912 21.8485C13.1785 21.8485 10.4932 19.1639 10.4932 15.8524C10.4932 14.1966 11.8359 12.8544 13.4922 12.8544C15.1485 12.8544 16.4912 14.1966 16.4912 15.8524C16.4912 17.5082 17.8339 18.8505 19.4902 18.8505C21.1465 18.8505 22.4892 17.5082 22.4892 15.8524Z"
      fill="#FFCD4D"
    />
    <defs>
      <filter
        id="filter0_dd_1474_18333"
        x="8.36572"
        y="8.24976"
        width="16.25"
        height="16.25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.375" />
        <feGaussianBlur stdDeviation="0.5625" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1474_18333"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.375" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.039 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1474_18333"
          result="effect2_dropShadow_1474_18333"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1474_18333"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1474_18333"
        x1="26.4458"
        y1="22.8903"
        x2="5.55518"
        y2="10.7496"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEC258" />
        <stop offset="0.493004" stopColor="#F8AA1E" />
        <stop offset="0.978599" stopColor="#FEC258" />
      </linearGradient>
    </defs>
  </svg>
)
